// Wiederverwendbarer Voice-Dropdown. Wird in TTS-Block-Params und STS-
// Recording-Overlay verwendet. Zeigt Optionen als "N — Voice-Name" mit
// Color-Dot links.

import type { Voice } from '@shared/types';
import { voiceColorVar, voiceDisplayName } from '@/lib/voiceMapping';
import styles from './VoicePicker.module.css';

interface Props {
  /** Aktuell ausgewählte voiceId. */
  value: string;
  /** Wird gerufen wenn der User eine andere Voice wählt. */
  onChange: (voiceId: string) => void;
  /** Erlaubte Voices für das aktuelle Asset (Reihenfolge = Spur-Reihenfolge). */
  assetVoiceIds: string[];
  /** Projekt-weite Voice-Liste (für Display-Namen). */
  voices: Voice[];
  /** Optional disabled state (z.B. während eines Generates). */
  disabled?: boolean;
}

export function VoicePicker({ value, onChange, assetVoiceIds, voices, disabled }: Props) {
  return (
    <div className={styles.wrap}>
      <span
        className={styles.dot}
        style={{ background: voiceColorVar(value, assetVoiceIds) }}
        aria-hidden="true"
      />
      <select
        className={styles.select}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        {assetVoiceIds.map((id) => (
          <option key={id} value={id}>
            {voiceDisplayName(id, assetVoiceIds, voices)}
          </option>
        ))}
      </select>
    </div>
  );
}
